// Identifies which grid a saved layout belongs to. A grid opts in to saved layouts by passing one of
// these as SquireDataGrid's `layoutKey`; no key means a plain grid.
//
// The values are persisted in GridLayouts.LayoutKey, so renaming one orphans every layout already
// saved under the old spelling — treat a change here as a data migration, not an edit. The
// accompanying test pins the exact strings for that reason.
//
// Two rules this file exists to enforce:
//   * Keys are compared by SQL Server, whose collation is case-insensitive, so 'Companies.List' and
//     'companies.list' would collide. Declaring them in one place is what makes that checkable.
//   * A key names a grid, never a grid *instance*. Nothing here is parameterised by record id, so a
//     layout saved on one project's copy of a grid applies to every project's copy.
//
// Shape is Page.GridRole. Most pages have a single list grid; the role only earns a distinct name
// when a page has more than one candidate grid, as on the rate sheet.
export const gridLayoutKeys = {
  accountsPayable: 'AccountsPayable.List',
  adminProjects: 'AdminProjects.List',
  adminRoles: 'AdminRoles.List',
  cashflow: 'Cashflow.List',
  companies: 'Companies.List',
  contacts: 'Contacts.List',
  estimateCategories: 'EstimateCategories.List',
  estimateTemplates: 'EstimateTemplates.List',
  estimates: 'Estimates.List',
  jobs: 'Jobs.List',
  opportunities: 'Opportunities.List',
  payments: 'Payments.List',
  profitAnalysis: 'ProfitAnalysis.List',
  rateSheetEstimateScopes: 'RateSheet.EstimateScopes',
};
